// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** RentAll - Begin **/
.HostingBlock-container-JJmvF {
	width: 100%;
	max-width: var(--max-container-width);
	padding: 0 15px;
}
.HostingBlock-seperator-KKd55 {
	background-color: var(--primary-border);
	width: 64px;
	display: block;
	height: 1.5px;
	margin: 0 auto;
	margin-bottom: 27px;
}
.HostingBlock-boxseperator-A2vrz {
	height: 2.5px;
	border: 1px solid var(--primary-border);
	background-color: transparent;
}
.HostingBlock-hostingsection-C3LTB {
	margin-bottom: 100px;
}
.HostingBlock-mainhedding-p1Hss h3 {
	font-size: 46px;
	line-height: 60px;
	text-align: center;
	font-weight: bold;
	margin: 100px 0 60px;
	color: var(--primary-foreground);
}
.HostingBlock-steps-SGLnB .HostingBlock-circle-r6cjh {
	background-color: var(--secondary-bg);
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	border-radius: 29px;
	width: 50px;
	height: 50px;
	text-align: center;
	margin-bottom: 20px;
}
.HostingBlock-steps-SGLnB .HostingBlock-circle-r6cjh span {
	display: block;
	margin: auto;
	color: #fff;
	font-weight: bold;
	font-size: 17px;
}
.HostingBlock-steps-SGLnB a {
	font-size: 17px;
}
h4.HostingBlock-common-bXk_l {
	font-size: 20px;
	font-weight: 600;
	margin-bottom: 17px;
}
p.HostingBlock-common-bXk_l {
	font-size: 16px;
	line-height: 24px;
	color: var(--secondary-foreground);
}
.HostingBlock-steps-SGLnB {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
	padding: 32px;
}
.HostingBlock-bannerImageBg-jlJDl {
	width: 100%;
	max-width: 60px;
	height: 60px;
	border-radius: 3px;
}
@media screen and (max-width: 991px) {
	h4.HostingBlock-common-bXk_l {
		font-size: 23px;
		font-weight: 600;
	}

	.HostingBlock-whyblock-fQX7Q {
		margin-bottom: 35px;
		padding-right: 0px;
		padding-left: 0px;
	}

	.HostingBlock-mainhedding-p1Hss h1 {
		font-size: 36px;
		line-height: 51px;
		margin-bottom: 13px;
	}

	.HostingBlock-steps-SGLnB {
		margin-top: 44px;
	}

	.HostingBlock-hostingsection-C3LTB {
		margin-bottom: 85px;
	}
}
@media screen and (max-width: 767px) {
	.HostingBlock-mainhedding-p1Hss h1 {
		font-size: 24px;
		line-height: 30px;
		margin: 30px 0;
		text-align: left;
	}

	.HostingBlock-steps-SGLnB {
		margin-top: 24px;
	}

	h4.HostingBlock-common-bXk_l {
		font-size: 20px;
	}

	.HostingBlock-hostingsection-C3LTB {
		margin-bottom: 45px;
	}

	p.HostingBlock-common-bXk_l {
		font-size: 14px;
		line-height: 1.7;
		font-weight: 400;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/WhyHost/HostingBlock/HostingBlock.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;CACC,WAAW;CACX,qCAAqC;CACrC,eAAe;AAChB;AAEA;CACC,uCAAuC;CACvC,WAAW;CACX,cAAc;CACd,aAAa;CACb,cAAc;CACd,mBAAmB;AACpB;AAEA;CACC,aAAa;CACb,uCAAuC;CACvC,6BAA6B;AAC9B;AAEA;CACC,oBAAoB;AACrB;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,iBAAiB;CACjB,oBAAoB;CACpB,gCAAgC;AACjC;AAEA;CACC,qCAAqC;CACrC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;AACpB;AAEA;CACC,cAAc;CACd,YAAY;CACZ,WAAW;CACX,iBAAiB;CACjB,eAAe;AAChB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kCAAkC;AACnC;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;AAEA;CACC,WAAW;CACX,eAAe;CACf,YAAY;CACZ,kBAAkB;AACnB;AAEA;CACC;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;CACpB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,mBAAmB;CACpB;AACD;AAEA;CACC;EACC,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;CACjB;AACD","sourcesContent":["/** RentAll - Begin **/\n.container {\n\twidth: 100%;\n\tmax-width: var(--max-container-width);\n\tpadding: 0 15px;\n}\n\n.seperator {\n\tbackground-color: var(--primary-border);\n\twidth: 64px;\n\tdisplay: block;\n\theight: 1.5px;\n\tmargin: 0 auto;\n\tmargin-bottom: 27px;\n}\n\n.boxseperator {\n\theight: 2.5px;\n\tborder: 1px solid var(--primary-border);\n\tbackground-color: transparent;\n}\n\n.hostingsection {\n\tmargin-bottom: 100px;\n}\n\n.mainhedding h3 {\n\tfont-size: 46px;\n\tline-height: 60px;\n\ttext-align: center;\n\tfont-weight: bold;\n\tmargin: 100px 0 60px;\n\tcolor: var(--primary-foreground);\n}\n\n.steps .circle {\n\tbackground-color: var(--secondary-bg);\n\tdisplay: flex;\n\tborder-radius: 29px;\n\twidth: 50px;\n\theight: 50px;\n\ttext-align: center;\n\tmargin-bottom: 20px;\n}\n\n.steps .circle span {\n\tdisplay: block;\n\tmargin: auto;\n\tcolor: #fff;\n\tfont-weight: bold;\n\tfont-size: 17px;\n}\n\n.steps a {\n\tfont-size: 17px;\n}\n\nh4.common {\n\tfont-size: 20px;\n\tfont-weight: 600;\n\tmargin-bottom: 17px;\n}\n\np.common {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tcolor: var(--secondary-foreground);\n}\n\n.steps {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n\tpadding: 32px;\n}\n\n.bannerImageBg {\n\twidth: 100%;\n\tmax-width: 60px;\n\theight: 60px;\n\tborder-radius: 3px;\n}\n\n@media screen and (max-width: 991px) {\n\th4.common {\n\t\tfont-size: 23px;\n\t\tfont-weight: 600;\n\t}\n\n\t.whyblock {\n\t\tmargin-bottom: 35px;\n\t\tpadding-right: 0px;\n\t\tpadding-left: 0px;\n\t}\n\n\t.mainhedding h1 {\n\t\tfont-size: 36px;\n\t\tline-height: 51px;\n\t\tmargin-bottom: 13px;\n\t}\n\n\t.steps {\n\t\tmargin-top: 44px;\n\t}\n\n\t.hostingsection {\n\t\tmargin-bottom: 85px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.mainhedding h1 {\n\t\tfont-size: 24px;\n\t\tline-height: 30px;\n\t\tmargin: 30px 0;\n\t\ttext-align: left;\n\t}\n\n\t.steps {\n\t\tmargin-top: 24px;\n\t}\n\n\th4.common {\n\t\tfont-size: 20px;\n\t}\n\n\t.hostingsection {\n\t\tmargin-bottom: 45px;\n\t}\n\n\tp.common {\n\t\tfont-size: 14px;\n\t\tline-height: 1.7;\n\t\tfont-weight: 400;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `HostingBlock-container-JJmvF`,
	"seperator": `HostingBlock-seperator-KKd55`,
	"boxseperator": `HostingBlock-boxseperator-A2vrz`,
	"hostingsection": `HostingBlock-hostingsection-C3LTB`,
	"mainhedding": `HostingBlock-mainhedding-p1Hss`,
	"steps": `HostingBlock-steps-SGLnB`,
	"circle": `HostingBlock-circle-r6cjh`,
	"common": `HostingBlock-common-bXk_l`,
	"bannerImageBg": `HostingBlock-bannerImageBg-jlJDl`,
	"whyblock": `HostingBlock-whyblock-fQX7Q`
};
module.exports = ___CSS_LOADER_EXPORT___;
